import { TranslationMap } from '@trimble-gcs/i18n-types';

export function optionsTranslations() {
  return {
    title: {
      text: $localize`:@@multiSelectedOptions.title:{count} Selected Items`,
      desc: 'Title of the multi-select options panel. The {count} value will always be larger than one.',
    },
    close: {
      tooltip: {
        text: $localize`:@@multiSelectedOptions.close.tooltip:Close`,
        desc: 'Tooltip for the top right "X" button that closes the multi-select options panel.',
      },
    },
    viewIn3d: {
      button: {
        text: $localize`:@@multiSelectedOptions.viewIn3d.button:View in 3D`,
        desc: 'Button text to view selected items in 3D.',
      },
      tooltip: {
        text: $localize`:@@multiSelectedOptions.viewIn3d.tooltip:View in 3D`,
        desc: 'Button tooltip to view selected items in 3D.',
      },
    },
    viewInNumark: {
      text: $localize`:@@multiSelectedOptions.viewInNumark:View in Multi-pane`,
      desc:
        'Button text to open the selected items in Numark. ' +
        "The term 'Multi-pane' is a brand name and not translated.",
    },
    editTags: {
      button: {
        text: $localize`:@@multiSelectedOptions.editTags.button:Edit Tags`,
        desc: 'Button text to edit tags for selected items.',
      },
      tooltip: {
        text: $localize`:@@multiSelectedOptions.editTags.tooltip:Edit Tags`,
        desc: 'Button tooltip to edit tags for selected items.',
      },
    },
    download: {
      button: {
        text: $localize`:@@multiSelectedOptions.download.button:Download`,
        desc: 'Button text to download selected items.',
      },
      tooltip: {
        text: $localize`:@@multiSelectedOptions.download.tooltip:Download`,
        desc: 'Button tooltip to download selected items.',
      },
    },
    delete: {
      button: {
        text: $localize`:@@multiSelectedOptions.delete.button:Recycle`,
        desc: 'Button text to delete selected items.',
      },
      tooltip: {
        text: $localize`:@@multiSelectedOptions.delete.tooltip:Recycle`,
        desc: 'Button tooltip to delete selected items.',
      },
    },
    selected: {
      text: $localize`:@@multiSelectedOptions.selected:Selected Items`,
      desc: 'Section header text above the list of selected items.',
    },
    remove: {
      tooltip: {
        text: $localize`:@@multiSelectedOptions.remove.tooltip:Remove`,
        desc: 'Tooltip for the remove button next to each selected item.',
      },
    },
  } satisfies TranslationMap;
}
